<div class="platform-form platform-form__lists">
  <div class="platform-form__top" *nzModalTitle>
    <h3 class="title">Notification</h3>
  </div>
  <div class="platform-form__content">
    {{ data.message }}
  </div>
  <div *nzModalFooter id="modalWindowJs" class="button-footer">
    <button
      type="submit"
      nz-button
      nzType="primary"
      id="confirmButton"
      (click)="onAccept()"
    >
      Accept
    </button>
    <button
      type="button"
      nz-button
      nzType="default"
      id="closeButton"
      (click)="onCancel()"
    >
      Close
    </button>
  </div>
</div>
